import { createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-6387ac0f"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  class: "offline_stock_import"
};
const _hoisted_2 = {
  class: "base_details_content"
};
const _hoisted_3 = {
  class: "content"
};
const _hoisted_4 = {
  class: "base_details_title_button"
};

const _hoisted_5 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "tb_title"
}, "导入库存信息", -1));

const _hoisted_6 = {
  class: "base_details_content_second"
};

const _hoisted_7 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "el-upload__text"
}, [/*#__PURE__*/_createTextVNode(" 将Excel表格拖到此处，或"), /*#__PURE__*/_createElementVNode("em", null, "点击上传")], -1));

const _hoisted_8 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "el-upload__tip"
}, [/*#__PURE__*/_createElementVNode("div", null, "注意："), /*#__PURE__*/_createElementVNode("div", null, "1.请严格按照Excel表格模板录入信息"), /*#__PURE__*/_createElementVNode("div", null, "2.不要改动Excel表格模板格式")], -1));

import BackTitleView from "@com/BackTitleView.vue";
import { UploadFilled } from '@element-plus/icons-vue';
import $ from "@util/base";
import { ref } from "vue";
import { UPLOAD_FILE_URL } from "@net/url";
import auth from "@net/auth";
import { $msg } from "@ui/msg";
import useRoute from "@util/router";
import api from "@api/goodsStock";
const name = 'file_data';
export default {
  __name: 'OfflineStockImport',

  setup(__props) {
    const route = useRoute();
    const url = UPLOAD_FILE_URL; // 上传文件字段名

    const headers = {
      accessToken: auth.getToken()
    };

    function downloadTemplate() {
      api.downloadTemplate(val => {
        $.download(val.url, "线下库存变更导入模板");
      });
    }

    const file = ref(null);

    function uploadSuccess(response) {
      if (response.code === 0) {
        file.value = response.data.fileUrl;
      }
    }

    function checkForm() {
      if ($.isEmpty(file.value)) {
        $msg.error("请上传Excel表格");
      } else {
        console.log(file.value);
        api.importStock(file.value, val => {
          $msg.succ("导入成功");
          back();
        });
      }
    }

    function back() {
      route.go(-1);
    }

    return (_ctx, _cache) => {
      const _component_el_button = _resolveComponent("el-button");

      const _component_el_icon = _resolveComponent("el-icon");

      const _component_el_upload = _resolveComponent("el-upload");

      const _component_el_main = _resolveComponent("el-main");

      const _component_el_footer = _resolveComponent("el-footer");

      const _component_el_container = _resolveComponent("el-container");

      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_el_container, {
        class: "base_details_container"
      }, {
        default: _withCtx(() => [_createVNode(BackTitleView, {
          title: "线下库存变更导入"
        }), _createVNode(_component_el_main, null, {
          default: _withCtx(() => [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_hoisted_5, _createVNode(_component_el_button, {
            type: "primary",
            onClick: downloadTemplate
          }, {
            default: _withCtx(() => [_createTextVNode("下载模板")]),
            _: 1
          })]), _createElementVNode("div", _hoisted_6, [_createVNode(_component_el_upload, {
            ref: "upload",
            action: _unref(url),
            accept: ".xls,.xlsx",
            name: name,
            headers: headers,
            "on-success": uploadSuccess,
            limit: 1,
            drag: ""
          }, {
            tip: _withCtx(() => [_hoisted_8]),
            default: _withCtx(() => [_createVNode(_component_el_icon, {
              class: "el-icon--upload"
            }, {
              default: _withCtx(() => [_createVNode(_unref(UploadFilled))]),
              _: 1
            }), _hoisted_7]),
            _: 1
          }, 8, ["action"])])])])]),
          _: 1
        }), _createVNode(_component_el_footer, null, {
          default: _withCtx(() => [_createVNode(_component_el_button, {
            onClick: back
          }, {
            default: _withCtx(() => [_createTextVNode("取消")]),
            _: 1
          }), _createVNode(_component_el_button, {
            onClick: checkForm,
            type: "primary"
          }, {
            default: _withCtx(() => [_createTextVNode("保存")]),
            _: 1
          })]),
          _: 1
        })]),
        _: 1
      })]);
    };
  }

};